import { useEffect, useState } from "react";

import { useEditorContext } from "../../context/editorContext";
import useDarkMode from "../../WidgetToolbar/widgetToolbarHelpers";
import { useAppQuoteContext } from "../../../../../../../context/AppQuoteContext";

const useNewRecordContainer = (props) => {
	const {quote, updateQuoteItems} = useAppQuoteContext();
	const { currentTab, onPopoverClose } = props;
	const { contentGrid: grid } = useEditorContext();
	const {manualSyncEnabled, setNeedsManualSync} = useAppQuoteContext();

	const [textFieldValue, setTextFieldValue] = useState("");
	const [dropdownValue, setDropdownValue] = useState("");
	const [numberValue, setNumberValue] = useState(1);
	const [currencyValue, setCurrencyValue] = useState(quote.formatCurrency(0));
	const [loadingCheckProduct, setLoadingCheckProduct] = useState(false);
	const [loadingAddProduct, setLoadingAddProduct] = useState(false);
	const [productError, setProductError] = useState(false);
	const [productChecked, setProductChecked] = useState(false);
	const isPackageLevelAuthorized = quosal.validation.isPackageLevelAuthorized(app.packageLevels.standard);
	const showGearIcon = app.currentUser.IsAdministrator && isPackageLevelAuthorized;

	const [dialogClasses, setDialogClasses] = useState("");
	const darkMode = useDarkMode();

	const getGroupOptions = () => {
		const groups = quosal.util.clone(quosal.sell.product.sourceGroups);
		if (groups && groups.length) {
			groups.sort((a, b) => {
				const textA = a.GroupName ? $.trim(a.GroupName.toUpperCase()) : "";
				const textB = b.GroupName ? $.trim(b.GroupName.toUpperCase()) : "";
				return textA < textB ? -1 : textA > textB ? 1 : 0;
			});
		}

		return groups;
	};

	const regexManipulation = (data) => {
		let price = String(data).trim();

		if (!price || !price.match(/[0-9]/)) {
			return 0;
		}

		const endsWithDot = price.endsWith(".");

		if ((price.match(/\./g) || []).length > 1) {
			const lastDotIndex = price.lastIndexOf(".");
			price =
				price.substring(0, lastDotIndex).replace(/\./g, "") + price.substring(lastDotIndex);
		} else {
			price = price.replace(/[^0-9.]/g, "");
		}

		let [integerPart, decimalPart] = price.split(".");

		integerPart = integerPart.replace(/^0+(?!\.|$)/, "");

		if (decimalPart && decimalPart.length > 2) {
			decimalPart = decimalPart.substr(0, 2);
		}

		decimalPart = decimalPart === "00" || !decimalPart ? "" : `.${decimalPart}`;

		price = integerPart + decimalPart;

		return endsWithDot && !decimalPart
			? `${price}.`
			: price.includes(".")
			? price
			: parseFloat(price);
	};
	// helpers end

	const resetDialog = () => {
		setTextFieldValue("");
		setDropdownValue("");
		setNumberValue(1);
		setCurrencyValue(quote.formatCurrency(0));
		setLoadingCheckProduct(false);
		setLoadingAddProduct(false);
		setProductError(false);
		setProductChecked(false);
	};

	const handleClose = () => {
		resetDialog();
		onPopoverClose();
	};

	const handleCheck = () => {
		if (!textFieldValue) {
			setProductError(true);
			return;
		}

		const checkProductApi = quosal.api.product.checkProduct(
			textFieldValue,
			quote.IdQuoteMain,
			currentTab.IdQuoteTabs,
			dropdownValue
		);

		checkProductApi.finished = function (msg) {
			setProductChecked(true);

			if (msg.exists) {
				setCurrencyValue(quote.formatCurrency(msg.item.QuoteItemPrice));
			}

			setLoadingCheckProduct(false);
		};

		setLoadingCheckProduct(true);
		checkProductApi.call();
	};

	const handleTextFieldChange = (event) => {
		setTextFieldValue(event.target.value);

		if (productChecked) {
			setNumberValue(1);
			setCurrencyValue(quote.formatCurrency(0));
			setProductChecked(false);
		}
	};

	const handleDropdownChange = (event) => {
		setDropdownValue(event.target.value);
	};

	const handleNumberChange = (event) => {
		setNumberValue(event.target.value);
	};

	const onQuantityBlur = () => {
		let value = numberValue;
		if (value === "") {
			value = "1";
		}
		
		value = value.toString().replace(/[^\d.-]/g, '') === '' ? "1" : value.toString().replace(/[^\d.-]/g, '')
		value = parseFloat(value);

		const max = 100000000;
		if (value > max) {
			value = max;
		}
		
		setNumberValue(value);
	};

	const handleCurrencyChange = (event) => {
		if (event.target.value !== null && event.target.value !== undefined) {
			const value = regexManipulation(event.target.value);

			setCurrencyValue(value);
		}
	};

	const onPriceFocus = () => {
		if (currencyValue) {
			const value = regexManipulation(currencyValue);

			setCurrencyValue(value);
		}
	};

	const onPriceBlur = () => {
		const value = currencyValue.toString().replace(/,/g, ".");
		const val = quote.formatCurrency(value);

		setCurrencyValue(val);
	};

	const allUpdatesFinishedCheck = () => {
		var isFinished = grid.itemsToQuickAdd.every(x => {
			return x.isOpFinished == true;
		});
		if (isFinished) {
			grid.itemsToQuickAdd = [];
			const forceUpdateApi = quosal.api.quote.forceUpdate(quote.IdQuoteMain);
			forceUpdateApi.finished = function (msg) {
				if(manualSyncEnabled){
					msg.partialResponse = msg.partialResponse || {};
					app.currentQuote.Items = [];
					msg.partialResponse.newItems = msg.quote.Items;
					msg.quote = null;
					quosal.sell.quote.updateFromApiResponse(msg);
					setNeedsManualSync(true);
				} else {
					quosal.sell.quote.updateFromApiResponse(msg);
				}
				setLoadingAddProduct(false);
			};
			forceUpdateApi.call();
		}
	}

	const handleUpdateProduct = (msg) => {
		const fieldChangeUpdates = [];
		const price = regexManipulation(currencyValue);

		if ((productChecked || price !== 0) && price !== msg.newItem.QuoteItemPrice) {
			fieldChangeUpdates.push({
				fields: { SuggestedPrice: price },
				queries: [
					{
						table: "QuoteItems",
						where: [
							{
								field: "IdQuoteItems",
								operator: "Equals",
								value: msg.newItem.IdQuoteItems
							}
						]
					}
				]
			});
		}

		if (numberValue > 0 && numberValue !== 1) {
			fieldChangeUpdates.push({
				fields: { Quantity: numberValue || 1 },
				queries: [
					{
						table: "QuoteItems",
						where: [
							{
								field: "IdQuoteItems",
								operator: "Equals",
								value: msg.newItem.IdQuoteItems
							}
						]
					}
				]
			});
		}

		if (fieldChangeUpdates.length > 0) {	
			const updateApi = quosal.api.data.update(
				fieldChangeUpdates,
				quote.IdQuoteMain
			);

			updateApi.finished = function (msg) {
				if (msg.partialResponse) {
					quosal.sell.quote.updatePartial(msg.partialResponse);
				}

				allUpdatesFinishedCheck();
			};

			updateApi.call();
		} else {
			allUpdatesFinishedCheck();
			setLoadingAddProduct(false);
		}
	};

	const handleNewProduct = (insertBefore, closeOnAdd) => {
		var mpn = textFieldValue;
		let contentGrid = grid;

        const itemsByTabId = quosal.util.getItemsByTabId(quote);
		const insertIndex = itemsByTabId[currentTab.IdQuoteTabs]?.length || 0;
		const newGuid = quosal.util.generateGuid();
        var newRow = {
            table: 'QuoteItems',
            id: newGuid,
            isUnsaved: true,
			IdQuoteItems: newGuid,
            IdQuoteMain: quote.IdQuoteMain,
            IdQuoteTabs: currentTab.IdQuoteTabs,
            ManufacturerPartNumber: mpn,
            Quantity: numberValue,
            IsTotalsIncluded: true,
            SortOrder: insertIndex,
            IsTaxable: currentTab.IsTaxable
        };
		
		updateQuoteItems(items => {
			return [...items, newRow];
		});

		const quickAdd = quosal.api.product.quickItemEntry(
			textFieldValue,
			quote.IdQuoteMain,
			currentTab.IdQuoteTabs,
			dropdownValue,
			insertBefore,
			false
		);

		quickAdd.newRow = newRow
        contentGrid.itemsToQuickAdd.push(quickAdd);
		

		quickAdd.finished = function (msg) {
			contentGrid.itemsToQuickAdd.find(x => {
                return x.opId == msg.opId
            }).isOpFinished = true;

			handleUpdateProduct(msg, closeOnAdd);
		};

		quickAdd.call();
		setLoadingAddProduct(false);
		resetDialog();
		if(closeOnAdd){
			handleClose();
		}
	};

	const handleSubmit = (closeOnAdd) => {
		if (!textFieldValue) {
			setProductError(true);
			return;
		}

		const insertBefore = grid.state.insertBefore ? grid.state.insertBefore : "";

		setLoadingAddProduct(true);
		handleNewProduct(insertBefore, closeOnAdd);
	};

	// helpers effect start
	useEffect(() => {
		const groups = getGroupOptions();
		const tabSourceGroup = quosal.util.getTabByTabId(app.currentQuote, grid?.state?.cKEditorSelectedTabId)?.PrimarySourceGroup;
		const foundTabSourceGroup = groups.find(group => group.IdProductSourceGroup === tabSourceGroup);	
		foundTabSourceGroup ? 
			setDropdownValue(foundTabSourceGroup.IdProductSourceGroup): 
			setDropdownValue(groups.find(group => group.IsPrimary)?.IdProductSourceGroup || ""); 
		
	}, [grid?.state?.cKEditorSelectedTabId, quosal.sell.product.sourceGroups]);

	useEffect(() => {
		setDialogClasses(darkMode ? "darkMode" : "");
	}, [darkMode]);

	return {
		handleClose,
		handleTextFieldChange,
		handleDropdownChange,
		handleNumberChange,
		onQuantityBlur,
		handleCurrencyChange,
		onPriceFocus,
		onPriceBlur,
		handleCheck,
		handleSubmit,
		getGroupOptions,
		dialogClasses,
		productError,
		textFieldValue,
		dropdownValue,
		showGearIcon,
		numberValue,
		currencyValue,
		loadingCheckProduct,
		loadingAddProduct
	};
};

export default useNewRecordContainer;
